<template>
	<v-container
		class="container-height d-flex align-center justify-center"
		fluid
		:class="reduced ? 'container-height-reduced' : 'container-height'"
	>
		<div class="text-center">
			<v-icon class="text--disabled" :size="isMobile ? 70 : 100"
				>mdi-database-remove</v-icon
			>
			<p
				class="text-center text--disabled font-weight-medium"
				:class="{
					'text-h5': isMobile,
					'text-h4': !isMobile,
				}"
			>
				{{ text }}
			</p>
		</div>
	</v-container>
</template>

<script>
export default {
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
		reduced: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: "No hay datos disponibles"
		}
	},
};
</script>

<style scoped>
.container-height {
	height: calc(100vh - 240px);
}

.container-height-reduced {
	height: calc(100vh - 400px);
}
</style>